import { Component, OnInit, SimpleChanges, OnChanges, Input, OnDestroy, ViewChild, ElementRef, AfterViewInit, Output,
  EventEmitter, Inject, HostListener} from '@angular/core';
import { DOCUMENT } from '@angular/common';

import _ from 'lodash';

@Component({
  selector: 'app-virtual-tours-video',
  templateUrl: './virtual-tours-video.component.html',
  styleUrls: ['./virtual-tours-video.component.scss']
})
export class VirtualToursVideoComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit  {
  @Input() spaceData;
  @Input() mediaData;
  @Input() floorplanData;
  @Input() selectedMedia;
  @ViewChild('mainDiv') mainDiv: ElementRef;
  @ViewChild('cssRendererContainer') cssRendererContainer: ElementRef;
  @ViewChild('rendererVideoContainer') rendererVideoContainer: ElementRef;
  @ViewChild('videoElement') videoElement: ElementRef;
  @Output() seletedMediaEmit = new EventEmitter();
  pointerEventsNone = false;
  cursorPointer = false;

  loading = true;
  playIconClicked = false;
  volumeIconClicked = false;
  isVideoPlaying = true;
  fullScreen = false;
  changeClass = false;
  // three js basic controls
  animateId: any;
  controls = null;
  title = null;
  renderer = null;
  scene = null;
  camera = null;
  ambientLight = null;
  pointLight = null;
  geometry = null;
  material = null;
  raycaster = new THREE.Raycaster();
  mouse = new THREE.Vector2(0, 0);
  manualControl = false;

  // Canvas config
  CANVAS_HEIGHT = 850;
  CANVAS_WIDTH = 1200;
  CANVAS_CENTER_X = 0;
  CANVAS_CENTER_Y = 0;

  sphereMesh = [];
  currentMesh: any;

  // VR effect
  effect: any;
  stereoEffect = false;

  spaceConfig = {
    show_drag: 1,
    auto_rotate: 1,
    show_control_buttons: 1,
    show_tour_button: 1
  };

  toolTipHover = false;

  // Camera rotation codes
  cameraConfig = {
    isUserInteracting: false,
    onMouseDownMouseX: 0,
    onMouseDownMouseY: 0,
    lon: 0,
    onMouseDownLon: 0,
    lat: 0,
    onMouseDownLat: 0,
    phi: 0,
    theta: 0,
    clientX: 0,
    clientY: 0,
    controlsSpeed: 600
  };

  // Opacity
  opacities = [];

  videoTexture: any;
  videoTime = 0;
  videoDuration = 0;

  hotspotColor = '#ffc378';
  hotspotMesh = [];
  editHotspots: any;

  cssScene = null;
  cssRenderer = null;


  videoTitleEnable = false;
  clickedPosition: any;
  currentTextMesh: any;
  currentTextGeometry: any;
  currentTextFont: any;

  isInfoModalClosed = false;

  setTimeoutValue = [];
  isBuffering = false;

  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
    fullscreenmode() {
      this.fullScreen = !this.fullScreen;
      this.resizeHandler({});
    }

  constructor(@Inject(DOCUMENT) private document: any) {
    this.initScene();
  }


  initScene() {
    this.scene = new THREE.Scene();
    // Css renderer
    this.cssScene = new THREE.Scene();
    this.cssRenderer = new THREE.CSS3DRenderer();
    this.renderer = new THREE.WebGLRenderer( { antialias: true } );
  }

  ngOnInit() {
    const thisobject = this;
    $('body').on('click', '#custom-seekbar', function(e) {
      console.log('clciked');
      const offset = $(this).offset();
      const left = (e.pageX - offset.left);
      const totalWidth = $('#custom-seekbar').width();
      const percentage = ( left / totalWidth );
      const vidTime = thisobject.videoElement.nativeElement.duration * percentage;
      console.log('vidTime', vidTime);
      thisobject.videoElement.nativeElement.currentTime = vidTime;
      thisobject.clearVideoTime();
    }); // click()
    // $('#bottom-content-block').delay(3000).fadeOut(3000).queue(function() {
    //   $(this).css('display', '');
    //   $(this).addClass('display-bottom');
    // });
    $('#mainDiv').hover(
      function() {
        $(this).addClass('');
      },
      function() {
        $(this).removeClass('display-bottom');
      }
    );
  }
  getCurrentVideoTime(event) {
    if (this.isVideoPlaying) {
      // For progress bar
      const percentage = ( this.videoElement.nativeElement.currentTime / this.videoElement.nativeElement.duration ) * 100;
      $('#custom-seekbar span').css('width', percentage + '%');

      this.videoTime = event.target.currentTime;
      // console.log('this.videoTime', this.videoTime);
      if (this.videoElement.nativeElement.networkState === this.videoElement.nativeElement.NETWORK_LOADING ||  this.videoElement.nativeElement.readyState <  this.videoElement.nativeElement.HAVE_FUTURE_DATA) {
        this.isBuffering = true;
      } else {
        this.isBuffering = false;
      }
      let i;
      for ( i = 0; i < this.hotspotMesh.length; i++) {
        const singleMesh = this.hotspotMesh[i];
        let userTime = 0;
        if (singleMesh && singleMesh.userData && singleMesh.userData.time && singleMesh.userData.time !== '') {
          // tslint:disable-next-line:radix
          userTime =  parseInt(singleMesh.userData.time);
          if (isNaN(userTime)) {
            userTime = 0;
          }
        }
        if (singleMesh && singleMesh.userData && this.videoTime && this.videoTime >= userTime && this.videoTime < (userTime + 5)) {
          this.showTextDiv(singleMesh.userData);
          this.setTimeoutValue.push(setTimeout(() => {
            this.hideTextDiv(singleMesh.userData);
          }, 5000));
        }
      }
    }
  }

  showTextDiv(hotspot) {
    if ($('#' + hotspot.uuid)) {
      $('#' + hotspot.uuid).css( {
        visibility: 'visible',
        opacity: 1
      });
    }
  }

  hideTextDiv(hotspot) {
    if ($('#' + hotspot.uuid)) {
      $('#' + hotspot.uuid).css( {
        visibility: 'hidden',
        opacity: 0
      });
    }
  }

  ngAfterViewInit() {
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.spaceData && changes.spaceData.currentValue) {
      this.updateSpaceConfig(changes.spaceData.currentValue.config);
    }
  }

  updateSpaceConfig(configData) {
    this.spaceConfig.show_drag = configData.show_drag ? configData.show_drag : false;
    this.spaceConfig.auto_rotate = configData.auto_rotate  ? configData.auto_rotate : false;
    this.spaceConfig.show_control_buttons = configData.show_control_buttons  ? configData.show_control_buttons : false;
    this.spaceConfig.show_tour_button = configData.show_tour_button  ? configData.show_tour_button : false;
  }

  onMouseMove( event ) {

    if (this.camera) {
      // Image rotation
      if ( this.cameraConfig.isUserInteracting === true ) {
        if ((event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
        ) {
          this.cameraConfig.clientX = event.clientX || (event.tources && event.tources[0] && event.touches[ 0 ].clientX ? event.touches[ 0 ].clientX : 0);
          this.cameraConfig.clientY = event.clientY || (event.tources && event.tources[0] && event.touches[ 0 ].clientY ? event.touches[ 0 ].clientY : 0);

          // tween opacity back to originals
          const targetLat = ( this.cameraConfig.clientY - this.cameraConfig.onMouseDownMouseY ) * 0.2 + this.cameraConfig.onMouseDownLat;
          const targetLon = ( this.cameraConfig.onMouseDownMouseX - this.cameraConfig.clientX ) * 0.2 + this.cameraConfig.onMouseDownLon;

          if (targetLat && targetLon) {
            const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
              .to({ lat: targetLat, lon: targetLon}, this.cameraConfig.controlsSpeed)
              .easing(TWEEN.Easing.Quadratic.Out)
              .onUpdate(() => {
              })
              .onComplete(() => {
              });
            tweenOpacity.start();
          }
        }
        this.manualControl = true;
        const canvasBounds = this.renderer.context.canvas.getBoundingClientRect();
        this.mouse.x = ( ( event.clientX - canvasBounds.left ) / ( canvasBounds.right - canvasBounds.left ) ) * 2 - 1;
        this.mouse.y = - ( ( event.clientY - canvasBounds.top ) / ( canvasBounds.bottom - canvasBounds.top) ) * 2 + 1;
        this.raycaster.setFromCamera( this.mouse, this.camera );
        if (this.currentMesh && this.currentMesh.children && this.currentMesh.children.length > 0) {
          const intersectionPointer = this.raycaster.intersectObjects(this.currentMesh.children, true);
          if (intersectionPointer[0]) {
            this.cursorPointer = true;
          } else {
            this.cursorPointer = false;
          }
        }
      }
    }
  }

  onMouseDown(event) {
    if (this.camera) {
      if ((event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
      (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
      ) {
        this.manualControl = false;
        this.cameraConfig.isUserInteracting = true;
        this.cameraConfig.clientX = (event && event.clientX) || (event && event.touches[ 0 ].clientX);
        this.cameraConfig.clientY = (event && event.clientY) || (event && event.touches[ 0 ].clientY);
        this.cameraConfig.onMouseDownMouseX = this.cameraConfig.clientX;
        this.cameraConfig.onMouseDownMouseY = this.cameraConfig.clientY;
        this.cameraConfig.onMouseDownLon = this.cameraConfig.lon;
        this.cameraConfig.onMouseDownLat = this.cameraConfig.lat;
      }
    }
  }

  onMouseUp(event) {
    if (this.camera) {
      if ((event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
        ) {
        // Camera rotation and sphere rotation
        this.cameraConfig.isUserInteracting = false;
      }
    }
  }

  init() {

    this.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererVideoContainer.nativeElement).width));
    this.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererVideoContainer.nativeElement).height));
    this.CANVAS_CENTER_X = this.CANVAS_WIDTH / 2;
    this.CANVAS_CENTER_Y = this.CANVAS_HEIGHT / 2;

    // Css renderer
    this.cssRenderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    this.cssRenderer.domElement.style.position = 'absolute';
    this.cssRenderer.domElement.style.top = 0;
    this.cssRendererContainer.nativeElement.appendChild(this.cssRenderer.domElement);

    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    this.renderer.setClearColor('#0C7CA5', 0);

    this.rendererVideoContainer.nativeElement.appendChild(this.renderer.domElement);
    // Web vr
    // this.renderer.vr.enabled = true;
    // this.rendererVideoContainer.nativeElement.appendChild( WEBVR.createButton( this.renderer, { frameOfReferenceType: 'head-model' } ) );

    this.camera = new THREE.PerspectiveCamera( 120, this.CANVAS_WIDTH / this.CANVAS_HEIGHT, 1, 1000 );
    this.camera.target = new THREE.Vector3( 0, 0, 0 );
    this.playIconClicked = this.spaceConfig.auto_rotate ? true : false;
    // VR effect
    // Add the VR screen effect.
    this.effect = new THREE.StereoEffect(this.renderer);
    // this.effect.eyeSeparation = 5;
    this.effect.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );


    // scene
    this.ambientLight = new THREE.AmbientLight( 0xcccccc, 0.4 );
    this.scene.add( this.ambientLight );
    this.pointLight = new THREE.PointLight( 0xffffff, 0.8 );
    this.camera.add( this.pointLight );
    this.scene.add( this.camera );

    this.createVideoSphere();
    this.animate();
  }

  createVideoSphere() {
    const geometry = new THREE.SphereBufferGeometry( 500, 60, 40 );
    // invert the geometry on the x-axis so that all of the faces point inward
    geometry.scale( - 1, 1, 1 );
    // const video = this.videoElement.nativeElement;
    this.videoElement.nativeElement.muted = true;
    this.videoElement.nativeElement.loop = true;
    this.videoElement.nativeElement.muted = true;
    this.videoElement.nativeElement.setAttribute( 'webkit-playsinline', 'webkit-playsinline' );
    this.videoElement.nativeElement.play();

    this.videoTexture = new THREE.VideoTexture( this.videoElement.nativeElement );
    this.videoTexture.minFilter = THREE.LinearFilter;
    this.videoTexture.format = THREE.RGBFormat;
    const material = new THREE.MeshBasicMaterial( { map: this.videoTexture } );
    this.sphereMesh = new THREE.Mesh( geometry, material );
    this.scene.add( this.sphereMesh );
    this.videoDuration = this.videoElement.nativeElement.duration;
    this.insertTextMesh();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  insertTextMesh() {
    if (this.selectedMedia.hotspot && this.selectedMedia.hotspot.length) {
      const hotspotData = this.selectedMedia.hotspot;
      let i;
      for (i = 0; i < hotspotData.length; i++) {
        const hotspots = hotspotData[i];
        this.createMediaHotspot(hotspots);
      }
    }
  }

  createMediaHotspot(hotspot) {
    const color = hotspot.color ? hotspot.color : this.hotspotColor;
    let content = '';
    content += '<div class="hotspot-video-text" data-id="' + hotspot.uuid + '" id="' + hotspot.uuid + '" style="visibility: hidden;opacity: 0;">';
    content += '<div class="text-block" style="color: ' + color + '"></div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;

    const sprite = new THREE.CSS3DSprite( element );
    // this.fixOrientation(sprite);
    sprite.scale.set(0.1, 0.1, 0.1);

    sprite.position.set(hotspot.coordinates.x, hotspot.coordinates.y, hotspot.coordinates.z);
    sprite.name = hotspot.uuid;
    sprite.userData = hotspot;
    this.hotspotMesh.push(sprite);
    this.cssScene.add( sprite );

    setTimeout(() => {
      const divElement = $('#' + hotspot.uuid);
      if (divElement) {
        const children = divElement.find('.text-block');
        if (children) {
          children.html(hotspot.title);
        }
      }
    }, 500);

  }

  // fixOrientation(mesh) {
  //   mesh.setRotationFromQuaternion(this.camera.quaternion);
  //   mesh.updateMatrix();
  // }

  animate() {
    this.animateId = requestAnimationFrame(this.animate.bind(this));
    // Rotate 360 image
    if ( this.cameraConfig.isUserInteracting === false && this.playIconClicked) {
      this.cameraConfig.lon += 0.1;
    }

    if (this.camera) {
      this.cameraConfig.lat = Math.max( - 85, Math.min( 85, this.cameraConfig.lat ) );
      this.cameraConfig.phi = THREE.Math.degToRad( 90 - this.cameraConfig.lat );
      this.cameraConfig.theta = THREE.Math.degToRad( this.cameraConfig.lon );
      this.camera.target.x = 500 * Math.sin( this.cameraConfig.phi ) * Math.cos( this.cameraConfig.theta );
      this.camera.target.y = 500 * Math.cos( this.cameraConfig.phi );
      this.camera.target.z = 500 * Math.sin( this.cameraConfig.phi ) * Math.sin( this.cameraConfig.theta );
      this.camera.lookAt( this.camera.target );
      this.updateMetaTagsRotationOnMouseMove();
      TWEEN.update();
      this.render();
    }
  }

  render() {
    if (this.renderer) {
      if (this.stereoEffect) {
        this.effect.render(this.scene, this.camera);
      } else {
        this.renderer.render(this.scene, this.camera);
      }
    }
    if (this.cssRenderer) {
      this.cssRenderer.render( this.cssScene, this.camera );
    }
  }

  resizeHandler(event) {

    if (this.renderer) {

      if ( this.fullScreen) {
        this.CANVAS_WIDTH = window.innerWidth;
        this.CANVAS_HEIGHT = window.innerHeight;
      } else {
        this.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererVideoContainer.nativeElement).width));
        this.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererVideoContainer.nativeElement).height));
      }

      this.camera.aspect = this.CANVAS_WIDTH / this.CANVAS_HEIGHT;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    }
    // Vr effect
    if (this.effect) {
      this.effect.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    }
    // Css renderer
    if (this.cssRenderer) {
      this.cssRenderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    }
  }

  ngOnDestroy() {
    this.removeComponentProperties();
  }

  playPauseVirtualTours() {
    this.playIconClicked = !this.playIconClicked;
  }

  openFullscreen() {
    if (!this.fullScreen) {
      const element  = this.mainDiv.nativeElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  }

  exitFullScreen(event) {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      this.document.msExitFullscreen();
    }
  }

  enableVrMode() {
    this.stereoEffect = !this.stereoEffect;
    this.resizeHandler(true);
    this.render();
  }

  rightControls() {
    const targetLon = this.cameraConfig.lon + 20;
    const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
      .to({ lon: targetLon}, this.cameraConfig.controlsSpeed)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate(() => {
      })
      .onComplete(() => {
      });
    tweenOpacity.start();

  }

  leftControls() {
    const targetLon = this.cameraConfig.lon - 20;
    const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
      .to({ lon: targetLon}, this.cameraConfig.controlsSpeed)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate(() => {
      })
      .onComplete(() => {
      });
    tweenOpacity.start();
  }

  upControls() {

    const targetLat = this.cameraConfig.lat + 20;
    const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
      .to({ lat: targetLat}, this.cameraConfig.controlsSpeed)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate(() => {
      })
      .onComplete(() => {
      });
    tweenOpacity.start();
  }

  downControls() {

    const targetLat = this.cameraConfig.lat - 20;
    const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
      .to({ lat: targetLat}, this.cameraConfig.controlsSpeed)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate(() => {
      })
      .onComplete(() => {
      });
    tweenOpacity.start();
  }

  getPlayPauseText() {
    if (this.playIconClicked) {
      return 'Off';
    }
    return 'On';
  }

  getPlayPauseVideoText() {
    if (this.isVideoPlaying) {
      return 'Pause';
    }
    return 'Play';
  }

  playPauseVideo() {
    if (this.isVideoPlaying) {
        this.isVideoPlaying = false;
        this.videoElement.nativeElement.pause();
        this.clearVideoTime();
    } else {
      this.isVideoPlaying = true;
      this.videoElement.nativeElement.play();
    }
  }

  clearVideoTime() {
    let i;
    for ( i = 0; i < this.setTimeoutValue.length; i++) {
      clearTimeout(this.setTimeoutValue[i]);
    }
    const percentage = ( this.videoElement.nativeElement.currentTime / this.videoElement.nativeElement.duration ) * 100;
    $('#custom-seekbar span').css('width', percentage + '%');
  }

  getmuteUnmuteText() {
    if (!this.volumeIconClicked) {
      return 'Unmute';
    }
    return 'Mute';
  }

  muteUnmuteVideo() {
    this.volumeIconClicked = !this.volumeIconClicked;
    if (this.volumeIconClicked) {
      this.videoElement.nativeElement.muted = false;
    } else {
      this.videoElement.nativeElement.muted = true;
    }
  }

  removeComponentProperties() {

    const gl = this.renderer.getContext('webgl');
    if (gl) {
      try {
        gl.getExtension('WEBGL_lose_context').loseContext();
      } catch {
        console.log('error');
      }
    }

    this.removeCssComponents();

    cancelAnimationFrame(this.animateId); // Stop the animation
    this.renderer.domElement.addEventListener('dblclick', null, false); // remove listener to render
    if (this.sphereMesh) {
      this.scene.remove(this.sphereMesh);
    }
    this.sphereMesh = undefined;
    this.scene = null;
    this.camera = null;
    this.controls = null;
    this.empty(this.rendererVideoContainer.nativeElement);
    this.empty(this.cssRendererContainer.nativeElement);
    this.removeData();
  }

  removeCssComponents() {
    // if ($('.hotspot-pulse')) {
    //   $('.hotspot-pulse').each(function() {
    //     $(this).remove();
    //   });
    // }
    // if ($('.info-outer')) {
    //   $('.info-outer').each(function() {
    //     $(this).remove();
    //   });
    // }
    // let i;
    // for (i = 0; i < this.hotspotsMesh.length; i++) {
    //     if (this.hotspotsMesh[i]) {
    //       this.cssScene.remove(this.hotspotsMesh[i]);
    //     }
    // }
    // this.hotspotsMesh = [];
    // // Remove info hotspot mesh
    // let j;
    // for (j = 0; j < this.hotspotsInfoMesh.length; j++) {
    //     if (this.hotspotsInfoMesh[j]) {
    //       this.cssScene.remove(this.hotspotsInfoMesh[j]);
    //     }
    // }
    // this.hotspotsInfoMesh = [];
}

  empty(elem) {
    while (elem.lastChild) {
      elem.removeChild(elem.lastChild);
    }
  }

  removeData() {
    this.cameraConfig.lat = 0;
    this.cameraConfig.lon = 0;
    this.sphereMesh = null;
  }

  updateMetaTagsRotationOnMouseMove() {
    let i;
    for (i = 0; i < this.hotspotMesh.length; i++) {
      const ringMesh = this.hotspotMesh[i];
      ringMesh.setRotationFromQuaternion(this.camera.quaternion);
      ringMesh.updateMatrix();
    }
  }

  mouseOutclass() {
    this.changeClass = false;
  }

}
